import { AdArea } from 'components/ad-area'
import { EzoicAd } from 'components/ezoic'
import { IS_PRODUCTION } from 'constants/app'
import { EZOIC } from 'constants/ezoic'
import { useIsTabletDown } from 'hooks/use-is-tablet-down'
import { ReactNode, useMemo } from 'react'

import { Centered, Wrapper } from './with-ads.styles'

const LEFT_INS_ID = 'with-ads-left-ins'
const RIGHT_INS_ID = 'with-ads-right-ins'

interface WithAdsProps {
  children: ReactNode
  hideAds?: boolean
}

const RAIL = 336 // supports 300 & 336 units
const GAP = 16

export const WithAds = (props: WithAdsProps) => {
  const { children, hideAds } = props

  const isTabletDown = useIsTabletDown()
  // const { shouldShowAds } = useAdsVisibility()
  const showAds = IS_PRODUCTION && !isTabletDown && !hideAds

  // Per Ezoic docs: combine all placement IDs into a single showAds() call
  // for better performance and reduced server requests
  const allPlacementIds = useMemo(() => [EZOIC.placements.sidebarFloating1, EZOIC.placements.sidebarFloating2], [])

  return (
    <Wrapper data-cy="with-ads-wrapper">
      {showAds && (
        <AdArea rightPadding={GAP} leftMargin={-RAIL} height={600} width={RAIL} insId={LEFT_INS_ID}>
          <div id={`ezoic-pub-ad-placeholder-${EZOIC.placements.sidebarFloating1}`} />
        </AdArea>
      )}

      <Centered>{children}</Centered>

      {showAds && (
        <>
          <AdArea insId={RIGHT_INS_ID} leftPadding={GAP} rightMargin={-RAIL} height={600} width={RAIL}>
            <div id={`ezoic-pub-ad-placeholder-${EZOIC.placements.sidebarFloating2}`} />
          </AdArea>

          {/* Single showAds() call for all placements on this page per Ezoic best practices */}
          <EzoicAd ids={allPlacementIds} />
        </>
      )}
    </Wrapper>
  )
}
